<div #global class="global-table-container">
  <p-table
    #pTable
    id="tabla"
    [value]="_internalList"
    [columns]="getColumns()"
    [resizableColumns]="true"
    [scrollable]="true"
    [reorderableColumns]="true"
    styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm"
    [rowHover]="true"
    class="table"
    currentPageReportTemplate=" {first}-{last} de {totalRecords} resultados"
    [lazy]="true"
    (onLazyLoad)="onTableDataChange($event)"
  >
    <!-- Section for Table support buttons -->
    <ng-template *ngIf="hasClearButton" pTemplate="caption">
      <div class="p-d-flex">
        <!-- eslint-disable @angular-eslint/template/elements-content -->
        <button
          id="clearFiltersButton"
          pButton
          label="Borrar"
          class="button button-lightBlue-outline mr-2 clean-button"
          icon="pi pi-filter-slash"
          (click)="onClearFilters()"
        ></button>
        <sbi-cot-back-button-table-config
          *ngIf="this.hasConfigurationTableButton"
          [listColumns]="listConfigColumns"
          [isLoading]="_getConfigListadoRequested$ | async"
          (changeConfig)="onChangeConfig($event)"
          (saveConfig)="onSaveConfig()"
        ></sbi-cot-back-button-table-config>
      </div>
    </ng-template>

    <!-- TABLE HEADER -->
    <ng-template pTemplate="header" let-columns="columns">
      <tr>
        <th class="check-column" pFrozenColumn>
          <label
            *ngIf="hasCheckBoxList"
            class="custom-checkbox-container custom-checkbox"
          >
            <input
              [checked]="checkAll"
              (click)="toggleFilterCheckAll(!checkAll)"
              type="checkbox"
            />
            <span class="checkmark">
              <i class="fas fa-check"></i>
            </span>
          </label>
        </th>
        <ng-container *ngFor="let col of getColumns()">
          <ng-template #headerTemplate>
            <ng-container>
              <span>{{ col.header }}</span>
              <span *ngIf="col.sort">
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </span>
              <span *ngIf="!!col.filterType">
                <p-columnFilter
                  *ngIf="
                    col.filterType !== 'text' &&
                    col.filterType !== 'dropdown' &&
                    col.filterType !== 'date' &&
                    col.filterType !== 'numeric'
                  "
                  type="{{ col.filterType }}"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [matchModeOptions]="col.matchModeOptions"
                ></p-columnFilter>

                <p-columnFilter
                  *ngIf="
                    col.filterType === 'text' || col.filterType === 'numeric'
                  "
                  type="{{ col.filterType }}"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [matchModeOptions]="col.matchModeOptions"
                  [matchMode]="col?.matchModeOptions?.[0].value || 'contains'"
                ></p-columnFilter>

                <p-columnFilter
                  *ngIf="col.filterType === 'dropdown'"
                  [matchModeOptions]="col.matchModeOptions"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [ngModel]="value"
                      [options]="col.filteOptions"
                      optionLabel="name"
                      optionValue="value"
                      (onChange)="filter($event.value)"
                      [placeholder]="col.header"
                      [showClear]="true"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
                <p-columnFilter
                  *ngIf="col.filterType === 'date'"
                  [matchModeOptions]="col.matchModeOptions"
                  display="menu"
                  field="{{ col.field }}"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="{{ col.filterType }}"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                    *ngIf="!col.filterBy"
                  >
                    <p-datepicker
                      #calendar
                      view="month"
                      [ngModel]="value"
                      (onSelect)="filter(calendar.value)"
                      (onInput)="onInputDate(calendar.value, col.field)"
                      dateFormat="mm/yy"
                    ></p-datepicker>
                  </ng-template>

                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                    *ngIf="col.filterBy === 'day'"
                  >
                    <p-datepicker
                      #calendar2
                      [ngModel]="value"
                      (onSelect)="filter(calendar2.value)"
                      (onInput)="onInputDate(calendar2.value, col.field)"
                      dateFormat="dd/mm/yy"
                    ></p-datepicker>
                  </ng-template>
                </p-columnFilter>
              </span>
            </ng-container>
          </ng-template>
          <th
            *ngIf="!col.frozen"
            [pSortableColumn]="col.sort ? col.field : ''"
            [ngClass]="col.class"
          >
            <div class="sort-header">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            </div>
          </th>
          <th
            *ngIf="col.frozen && this.showActionHeader"
            [pSortableColumn]=""
            pFrozenColumn
            [frozen]="col.frozen"
            [alignFrozen]="col.alignFrozen"
            [ngClass]="col.class"
          >
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
          </th>
        </ng-container>
      </tr>
    </ng-template>

    <!-- TABLE BODY SROLLABLE -->
    <ng-template
      pTemplate="body"
      let-acc
      let-columns="columns"
      let-i="rowIndex"
    >
      <tr class="p-selectable-row">
        <!-- added style directly in property because there is another property !important in styles.scss -->
        <td
          *ngIf="hasCheckBoxList && !this.loading"
          class="check-column"
          pFrozenColumn
          style="padding: 0.5rem !important"
        >
          <label class="custom-checkbox-container custom-checkbox">
            <input
              [attr.id]="i"
              [checked]="this.internalCheckList[i].checked"
              (click)="toggleRowFilterCheck(i)"
              type="checkbox"
            />
            <span class="checkmark">
              <i class="fas fa-check"></i>
            </span>
          </label>
        </td>
        <ng-container *ngFor="let col of columns">
          <ng-template #bodyTemplate>
            <ng-container *ngIf="!col.template">
              {{ acc[col.field] }}
            </ng-container>
            <ng-container *ngIf="col.template">
              <ng-container
                *ngTemplateOutlet="
                  col.template;
                  context: { $implicit: { col: col, acc: acc } }
                "
              ></ng-container>
            </ng-container>
          </ng-template>
          <td
            *ngIf="!col.frozen && !this.loading"
            [ngClass]="col.class + ' ui-resizable-column'"
          >
            <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
          </td>
          <td
            *ngIf="col.frozen && !this.loading"
            pFrozenColumn
            [frozen]="col.frozenType"
            [alignFrozen]="col.alignFrozen"
            [ngClass]="col.class"
          >
            <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>

  <div
    class="d-flex flex-row-reverse justify-content-between align-items-baseline cont"
    [ngClass]="{ 'hidden-paginator': !showPaginator }"
  >
    <p-paginator
      #paginator
      class="paginator"
      [rows]="rows"
      [totalRecords]="totalTableItems"
      [rowsPerPageOptions]="rowsPerPageOptions"
      (onPageChange)="paginate($event)"
    ></p-paginator>
    <div class="mt-2">
      <span class="results">{{ countTitle() }}</span>
    </div>
  </div>

  <div
    *ngIf="!loading && this._internalList?.length == 0"
    class="status-message"
  >
    <p>{{ noResultsMessage }}</p>
  </div>

  <app-prime-loader *ngIf="loading" [fullScreen]="true"></app-prime-loader>
</div>
